export default __webpack_public_path__ + "static/media/recruiter.9cbe9328.svg";